<template>
  <div class="flex items-center justify-between py-2.5">
    <div class="flex-1 min-w-0 pr-4">
      <p class="text-sm font-medium text-gray-700 dark:text-gray-200">{{ label }}</p>
      <p v-if="description" class="text-xs text-gray-400 dark:text-gray-500 mt-0.5">{{ description }}</p>
    </div>
    <button
      type="button"
      role="switch"
      :aria-checked="modelValue"
      @click="emit('update:modelValue', !modelValue)"
      class="relative flex-shrink-0 w-11 h-6 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1"
      :class="modelValue ? 'bg-blue-600' : 'bg-gray-200 dark:bg-gray-700'"
    >
      <span
        class="absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform duration-200"
        :class="modelValue ? 'translate-x-5' : 'translate-x-0'"
      ></span>
    </button>
  </div>
</template>

<script setup>
defineProps({
  label:       { type: String,  required: true },
  description: { type: String,  default: ''    },
  modelValue:  { type: Boolean, required: true },
})
const emit = defineEmits(['update:modelValue'])
</script>
